import colors from '@toolshed/styleguide/styles/colors';

export const BOX_SHADOW = `0px 3px 6px ${colors.boxShadow}`;
export const BORDER_RADIUS = '4px';
export const INPUT_RADIUS = `4px`;
export const NAV_HEIGHT = '64px';
export const NEW_BOX_SHADOW = '4px 4px 10px rgba(0, 0, 0, 0.15)';
export const CHECK_RADIO_SIZE = '30px';
export const INPUT_BORDER_LEFT = 4;
